import { render } from "./TransactionInInvoiceEditModal.vue?vue&type=template&id=375b1956&ts=true&lang=pug"
import script from "./TransactionInInvoiceEditModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransactionInInvoiceEditModal.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__